/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PracticeHubAccountStatus/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function PracticeHubAccountStatus({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/InApp/PracticeHubAccountStatus"
  
}) {
let threadSendToStatusValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'send_to_status',
format: fromHelpers.getType,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let threadSendToStatusValueData1 = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'send_to_status',
})
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 style="filled"
 data="thread.send_to_status"
 format="helpers.js getType"
 type={threadSendToStatusValueData}
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="thread.send_to_status"
 text={threadSendToStatusValueData1}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}